export const FEATURE_SWITCHES = {
   DISABLE_RECAPTCHA: 'disable_recaptcha'
}
